// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"StatusCell-index__badgeWrapper--F1hI9"};